/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Box, Text, Tooltip } from '@chakra-ui/react';
import React, { useEffect } from 'react';

const Q_SALE_STAFF = gql`
	query get($id: String!) {
		getCompanySaleProfessionalsTerminationById(id: $id) {
			id
			staff {
				id
				idCardNumber
				firstName
				lastName
				firstNameEn
				lastNameEn
			}
		}
	}
`;

export default function EventLoggingTerminatedSaleProfessional({ id = null }) {
	const [fetchData, { data }] = useLazyQuery(Q_SALE_STAFF);

	useEffect(() => {
		id && fetchData({ variables: { id } });
	}, [id]);

	return (
		<>
			{data?.getCompanySaleProfessionalsTerminationById?.id && (
				<Tooltip
					label={
						<Box>
							{data?.getCompanySaleProfessionalsTerminationById?.staff?.idCardNumber && (
								<Text color="white" fontWeight="semibold">
									{data?.getCompanySaleProfessionalsTerminationById?.staff?.idCardNumber}
								</Text>
							)}
							{(data?.getCompanySaleProfessionalsTerminationById?.staff?.firstName ||
								data?.getCompanySaleProfessionalsTerminationById?.staff?.lastName) && (
								<Text color="white" fontWeight="normal">
									{data?.getCompanySaleProfessionalsTerminationById?.staff?.firstName +
										' ' +
										data?.getCompanySaleProfessionalsTerminationById?.staff?.lastName}
								</Text>
							)}
							{(data?.getCompanySaleProfessionalsTerminationById?.staff?.firstNameEn ||
								data?.getCompanySaleProfessionalsTerminationById?.staff?.lastNameEn) && (
								<Text color="white" fontWeight="normal">
									{data?.getCompanySaleProfessionalsTerminationById?.staff?.firstNameEn +
										' ' +
										data?.getCompanySaleProfessionalsTerminationById?.staff?.lastNameEn}
								</Text>
							)}
						</Box>
					}
				>
					<Text cursor="pointer" fontSize="sm" fontWeight="semibold" color="gray.500">
						{data?.getCompanySaleProfessionalsTerminationById?.staff?.idCardNumber}
					</Text>
				</Tooltip>
			)}
		</>
	);
}
